<template>
  <members-import-wizard-component
    v-if="selectedPlan !== null && selectedPlan !== undefined"
    @finish="bulkImportFinished()"
    @close="$router.push({ name: 'members', params: { planId: selectedPlan.Id } })"
  ></members-import-wizard-component>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import MembersImportWizardComponent from "@/components/DataImport/MembersImportWizardComponent";
import { planSetter } from "../mixins/planSetter";
export default {
  name: "members-import-wizard",
  components: {
    MembersImportWizardComponent,
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    bulkImportFinished() {
      this.$router.push({ name: "members", params: { planId: this.selectedPlan.Id } });
    },
  },
};
</script>
